import { React, useState} from "react";
import { db } from '../firebase-config';
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { useNavigate } from 'react-router-dom';
import emailjs from '@emailjs/browser';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import NavbarDefault from "./components/navbarDefault";
import FooterDefault from "./components/footerDefault";
import InstantMessage from './InstantMessage.js';
import { createTheme, responsiveFontSizes } from "@mui/material";
import { ThemeProvider } from "@emotion/react";

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

function OpenTicket() {
  const [newFirstName, setNewFirstName] = useState("");
  const [newLastName, setNewLastName] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [newHelpTopic, setNewHelpTopic] = useState("");
  const [newHelpDetails, setNewHelpDetails] = useState("");
  const ticketsCollectionRef = collection(db, "tickets");
  const RequiredList = [newFirstName, newLastName, newEmail, newHelpTopic]
  
  const [FirstNameError, NewFirstNameError] = useState(false);
  const [LastNameError, NewLastNameError] = useState(false);
  const [EmailError, NewEmailError] = useState(false);
  const [HelpTopicError, NewHelpTopicError] = useState(false);
  const RequiredListError = [NewFirstNameError, NewLastNameError, NewEmailError , NewHelpTopicError]

  const [instant, setInstant] = useState(false); // Controls Alert
  const [severity, setSeverity] = useState(''); // Controls Severity
  const [message, setMessage] = useState('') // Controls Message

  const [FirstNameHT, NewFirstNameHT] = useState("");
  const [LastNameHT, NewLastNameHT] = useState("");
  const [EmailHT, NewEmailHT] = useState("");
  const [HelpTopicHT, NewHelpTopicHT] = useState("");
  const RequiredListHT = [NewFirstNameHT, NewLastNameHT, NewEmailHT, NewHelpTopicHT]
  const genHT = "Enter a valid "
  const RequiredFields = ['first name', 'last name', 'email address', 'mobile number', 'help topic']

  let navigate = useNavigate();

  const createTicket = async () => {
    const docRef = await addDoc(ticketsCollectionRef, {
      firstname: newFirstName, 
      lastname: newLastName,
      email: newEmail,
      helptopic: newHelpTopic,
      helpdetails: newHelpDetails,
      status: "Open",
      responsetime: "",
      datetime: serverTimestamp()
    });
    const emailparameters = {
      first_name: newFirstName,
      last_name: newLastName,
      email_address: newEmail,
      help_topic: newHelpTopic,
      help_details: newHelpDetails,
      ticket_id: docRef.id,
    };
    
    ///FUNCTION CALL FOR SENDING EMAIL COMMENT OUT IF TESTING CREATING TICKET ONLY///
    emailjs.send('DCS_Helpdesk_AGE', 'ticket_created', emailparameters, '6c5ETYq5Eis9dzAfX')
       .then(function(response) {
         console.log('SUCCESS!', response.status, response.text);
       }, function(error) {
         console.log('FAILED...', error);
       });
    ///FUNCTION CALL FOR SENDING EMAIL COMMENT OUT IF TESTING CREATING TICKET ONLY///

    navigate('/TicketCreated', {state:{ticketID: docRef.id}});
  };

  const HelpTopicsList = [
    {
      value: 'Enrollment',
      label: 'Enrollment',
    },
    {
      value: 'Shifting / Transferring',
      label: 'Shifting / Transferring',
    },
    {
      value: 'Leave of Absences / AWOL',
      label: 'Leave of Absences / AWOL',
    },
    {
      value: 'Residency',
      label: 'Residency',
    },
    {
      value: 'Appeals',
      label: 'Appeals',
    },
    {
      value: 'Facility Reservation',
      label: 'Facility Reservation',
    },
    {
      value: 'Student Organizations',
      label: 'Student Organizations',
    },
    {
      value: 'Others',
      label: 'Others',
    },
  ];

  const buttonStyle = { mt:1, mb:1, bgcolor: '#7B1113', ":hover": {bgcolor: "#5A0C0E", color: 'white'} };
  const cardStyle =  { maxWidth: 450, padding: "10px 5px", margin: "0 auto" };

  return (
    <ThemeProvider theme={theme}>

      {/* NAVIGATION BAR */}
      <NavbarDefault /> 

      <Box style={{ display:'flex', justifyContent:'center' }}>
        <Grid sx={{ mt:5, mb:5 }}>
          <Card sx={{ boxShadow:5, mb:3 }} style={cardStyle}>
            <CardContent>
              {instant ?  <InstantMessage sev = {severity} message = {message} /> : `` }
              <Typography align = "center" fontWeight="bold" component="h1" variant="h5">
                CREATE A TICKET
              </Typography>

              <Typography align="center" sx={{ mt:2, mb:3 }}>
              Please fill in the form below to open a new ticket.
              </Typography>
              <form>
                <Grid container spacing={1}>

                  {/* FIRST NAME TEXT BOX */}
                  <Grid xs={12} sm={6} item>
                    <TextField label="First Name" variant="outlined" helperText = {FirstNameHT} fullWidth required 
                    onChange={(event) => {
                      setInstant(false); 
                      setNewFirstName(event.target.value);
                      if (event.target.value === "" || event.target.value.length < 2 || ! Boolean(event.target.value.match(/^[A-Z Ñña-z]*$/))){
                        NewFirstNameHT("Enter a valid first name.");
                        NewFirstNameError(true);
                      }
                      else{
                        NewFirstNameHT("");
                        NewFirstNameError(false);
                      }
                    }}
                    error = {FirstNameError}
                    />
                  </Grid>

                  {/* LAST NAME TEXT BOX */}
                  <Grid xs={12} sm={6} item>
                    <TextField label="Last Name" variant="outlined" helperText = {LastNameHT} fullWidth required 
                    onChange={(event) => {
                      setInstant(false); 
                      setNewLastName(event.target.value);
                      if (event.target.value === "" || event.target.value.length < 2 || ! Boolean(event.target.value.match(/^[A-Z Ñña-z]*$/))){
                        NewLastNameHT("Enter a valid last name.");
                        NewLastNameError(true);
                      }
                      else{
                        NewLastNameHT("");
                        NewLastNameError(false);
                      }
                    }}
                    error = {LastNameError}
                    />
                  </Grid>
                  
                  {/* EMAIL ADDRESS TEXTBOX */}
                  <Grid item xs={12}>
                    <TextField type="email" placeholder="YourEmail@email.com" label="Email" variant="outlined" helperText = {EmailHT} fullWidth required 
                    onChange={(event) => {
                      setInstant(false); 
                      setNewEmail(event.target.value);
                    if (event.target.value === "" || ! event.target.value.match(/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/)){
                        NewEmailHT("Enter a valid email address.");
                        NewEmailError(true);
                      }
                      else{
                        NewEmailHT("")
                        NewEmailError(false);
                      }
                    }}
                    error = {EmailError}
                    />
                  </Grid>

                  {/* HELP TOPIC DROPDOWN */}
                  <Grid item xs={12}>
                    <TextField select label="Help Topic" variant="outlined" helperText = {HelpTopicHT} fullWidth required 
                    onChange={(event) => {
                      setInstant(false); 
                      NewHelpTopicHT("");
                      setNewHelpTopic(event.target.value);
                      NewHelpTopicError(false);
                    }}
                    error = {HelpTopicError}
                    >
                      {HelpTopicsList.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                        {option.label}
                        </MenuItem>
                      ))}
                    </TextField> 
                  </Grid>

                  {/* HELP DETAILS TEXT BOX */}
                  <Grid item xs={12}>
                    <TextField label="Help Details" multiline rows={4} placeholder="Describe your concern" variant="outlined" fullWidth 
                    onChange={(event) => {
                      setInstant(false); 
                      setNewHelpDetails(event.target.value);
                    }}
                    />
                  </Grid>

                  {/* Submit Button */}
                  <Grid item xs={12}>
                    <Button type="submit" variant="contained" sx={buttonStyle} fullWidth
                    onClick={e => {
                      e.preventDefault()
                      if(newFirstName && newLastName && newEmail && newHelpTopic && !(FirstNameError || LastNameError || EmailError || HelpTopicError)){
                        createTicket()
                      }
                      else{
                        setMessage("Please ensure all required inputs are valid.")
                        setSeverity("error")
                        setInstant(true); 
                        for (let i = 0; i < RequiredList.length; i++){
                          if (RequiredList[i] === "" && i < RequiredList.length - 1){
                            RequiredListError[i](true);
                            RequiredListHT[i](genHT+RequiredFields[i]+".")
                          }
                          else if (RequiredList[i] === "" && i === RequiredList.length - 1){
                            RequiredListError[i](true);
                            RequiredListHT[i]('Choose a help topic.')
                          }
                        }
                      }
                    }}
                    >
                    Submit
                    </Button>
                  </Grid>

                </Grid>
              </form>
            </CardContent>
          </Card>
        </Grid>
      </Box>  

      {/* FOOTER NAVIGATION */}
      <FooterDefault /> 

    </ThemeProvider>
  )
}

export default OpenTicket